import { useLocation } from '@reach/router';
import { Link as GatsbyLink } from 'gatsby';
import React, { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { isExternalLink } from './linkUtils';

const InternalLink = styled(GatsbyLink)`
  cursor: pointer;
  display: contents;
`;

const ExternalLink = styled.a`
  cursor: pointer;
`;

interface LinkWrapperProps {
  to: string;
}

// Use this component to wrap non-text elements e.g. a logo or icon
export const LinkWrapper: FC<PropsWithChildren<LinkWrapperProps>> = ({
  to,
  children,
}) => {
  const location = useLocation();
  const destination = `${to}${location.search}`;

  if (isExternalLink(to)) {
    return (
      <ExternalLink href={destination} target="_blank">
        {children}
      </ExternalLink>
    );
  }

  return <InternalLink to={destination}>{children}</InternalLink>;
};
